import React from 'react';

import triangleImage from './assets/triangle-image.gif';

const RightTriangleSquare = () => {
  return (
    <img src={triangleImage} alt="右矢印" />
  );
};

export default RightTriangleSquare;